module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0041.jpg?v=3691e55e";